import { IconDownload, IconFileInvoice } from "@tabler/icons-react";
import type { SaleDetailsDto } from "../../../../api";
import type { OrderStatus } from "../../../../components/common/chip";
import { Button } from "../../../../components/common/button";

interface OrderDocumentButtonProps {
  order: SaleDetailsDto;
  status?: OrderStatus;
}

interface DocumentLink {
  label: string;
  url: string;
  icon?: "invoice" | "download";
}

function buildDocuments(order: SaleDetailsDto, status?: OrderStatus): DocumentLink[] {
  const docs: DocumentLink[] = [];
  const isShipped = status && status !== "processing";

  if (order.previewUrl) {
    docs.push({ label: "Download order confirmation", url: order.previewUrl });
  }

  if (isShipped) {
    const shipments = order.dropshipping ?? [];
    shipments.forEach((shipment, index) => {
      if (shipment.previewUrl) {
        docs.push({
          label: shipments.length > 1 ? `Download delivery slip ${index + 1}` : "Download delivery slip",
          url: shipment.previewUrl,
        });
      }
    });
  }

  if (order.invoicePreviewUrl) {
    docs.push({ label: "View Invoice", url: order.invoicePreviewUrl, icon: "invoice" as const });
  }

  return docs;
}

export function OrderDocumentButton({ order, status }: OrderDocumentButtonProps) {
  const documents = buildDocuments(order, status);
  if (documents.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {documents.map((doc) => (
        <Button
          key={doc.url}
          variant={doc.icon === "invoice" ? "secondary" : "primary"}
          leftIcon={doc.icon === "invoice" ? <IconFileInvoice size={16} /> : <IconDownload size={16} />}
          onClick={() => window.open(doc.url, "_blank", "noopener,noreferrer")}
        >
          {doc.label}
        </Button>
      ))}
    </div>
  );
}
